// Weeks run Monday to Sunday in People (Rota, Timesheets), on the browser's clock.

export function mondayOf(date) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return d;
}

export function ymd(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function daysOf(weekStart) {
  return Array.from({ length: 7 }, (_, i) => new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + i));
}

// "19 – 25 Oct 2026", "29 Sep – 5 Oct 2026", "29 Dec 2026 – 4 Jan 2027"
export function weekWords(weekStart) {
  const end = new Date(weekStart.getFullYear(), weekStart.getMonth(), weekStart.getDate() + 6);
  const m = (d) => d.toLocaleDateString('en-GB', { month: 'short' });
  if (weekStart.getFullYear() !== end.getFullYear()) {
    return `${weekStart.getDate()} ${m(weekStart)} ${weekStart.getFullYear()} – ${end.getDate()} ${m(end)} ${end.getFullYear()}`;
  }
  if (weekStart.getMonth() !== end.getMonth()) return `${weekStart.getDate()} ${m(weekStart)} – ${end.getDate()} ${m(end)} ${end.getFullYear()}`;
  return `${weekStart.getDate()} – ${end.getDate()} ${m(end)} ${end.getFullYear()}`;
}

// How far through the week `now` is, 0..1, for the timesheet's bar.
export function throughWeek(weekStart, now = new Date()) {
  const ms = now - weekStart;
  return Math.max(0, Math.min(1, ms / (7 * 24 * 3600 * 1000)));
}
